import React, { useMemo } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Label,
} from "recharts";

const SideObservationGraph = ({ selectedObservation, mappedObservations }) => {
  const observationData = useMemo(() => {
    return mappedObservations.find(
      (item) => item.observationType === selectedObservation
    );
  }, [mappedObservations, selectedObservation]);

  const chartData = useMemo(() => {
    return observationData.objects.map((item) => ({
      date: new Date(item.resource.effectiveDateTime).toLocaleDateString(),
      value: item.resource.valueQuantity.value,
    }));
  }, [observationData.objects]);

  // Sort chartData array based on date in ascending order
  chartData.sort((a, b) => new Date(a.date) - new Date(b.date));

  // Find the minimum and maximum temperature values
  const minTemperature = Math.min(...chartData.map((item) => item.temperature));
  const maxTemperature = Math.max(...chartData.map((item) => item.temperature));

  // Calculate the padding for the Y-axis scale
  const yPadding = (maxTemperature - minTemperature) * 0.1; // Adjust the padding percentage as needed

  // Set the Y-axis domain
  const yDomain = [minTemperature - yPadding, maxTemperature + yPadding];

  // Custom tooltip content
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const temperature = payload[0].value;
      return (
        <div className="custom-tooltip">
          <p className="label">{`${observationData.observationType}: ${temperature}`}</p>
          <p className="date">{`Date: ${label}`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <LineChart
      width={700}
      height={400}
      data={chartData}
      margin={{ top: 30, right: 30, left: 30, bottom: 10 }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="date">
        <Label value="Date" position="insideBottom" offset={0} />
      </XAxis>
      <YAxis domain={yDomain}>
        <Label
          value={observationData.observationType}
          position="insideLeft"
          angle={-90}
          offset={-10}
        />
      </YAxis>
      <Tooltip content={<CustomTooltip />} />
      <Legend />
      <Line
        type="monotone"
        dataKey="value"
        stroke="blue"
        dot={true}
        curve="monotoneX"
      />
    </LineChart>
  );
};

export default SideObservationGraph;
